module.exports = __webpack_public_path__ + "img/icon_share.47764a90.svg";